import React from 'react';
import { staticYearList } from '../model/StaticVariables';
import PreparedMaps from './PreparedMaps';

const ContentInformation = () => {
    const yrs = staticYearList.slice(0, staticYearList.length - 1);
    const yrStr = yrs.map((y) => y.label).join(', ');
    return (
        <div role="tabpanel" id="panel-information-inner">
            <div id="info-text">
                <h2>
                    SVI Interactive Map <br />
                    Help Documentation
                </h2>

                <p>
                    <i>Our suggested citation for use of the SVI Interactive Map:</i>
                </p>
                <blockquote>
                    Centers for Disease Control and Prevention/Agency for Toxic Substances and Disease Registry/Geospatial Research, Analysis, and Services Program. CDC/ATSDR Social Vulnerability Index Interactive Map <strong>[Insert {yrStr}, or 2000]</strong> Database <strong>[Insert US or State]</strong>. <strong>[url of the interactive map]</strong>. Accessed on <strong>[Insert date]</strong>.
                </blockquote>

                <h3>Additional Resources</h3>
                <p>
                    The data for nursing homes, daycare centers, hospitals, and public schools under the “Map Features” come from the Homeland Infrastructure Foundation-Level Data (HIFLD). Search for the data of interest using this link:{' '}
                    <a target="_blank" href="https://hifld-geoplatform.hub.arcgis.com/pages/hifld-open">
                        HIFLD Open | HIFLD (arcgis.com).
                    </a>
                </p>
                <p>
                    The boundary files come from the U.S. Census Bureau for the year of the dataset (i.e. 2022 Census Cartographic Boundary File for the 2022 SVI dataset). The 2022 boundary files can be accessed using this link:{' '}
                    <a target="_blank" href="https://www.census.gov/geographies/mapping-files/time-series/geo/cartographic-boundary.2022.html#list-tab-1883739534">
                        Cartographic Boundary Files (census.gov).
                    </a>
                </p>
                <p>
                    <span>Visit these links to learn more about the CDC/ATSDR Social Vulnerability Index:</span>
                </p>
                <ul>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/index.html" target="_blank">
                            SVI Home Page
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/fact_sheet/fact_sheet.html" target="_blank">
                            SVI Fact Sheet
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/data_documentation_download.html" target="_blank">
                            SVI Data and Documentation
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/faq_svi.html" target="_blank">
                            Frequently Asked Questions
                        </a>
                    </li>
                </ul>
                <a name="preparedcountymaps">
                    <h3>County Map Series</h3>
                </a>
                <PreparedMaps />
                <p>
                    For more information, please contact the SVI Coordinator at
                    <a href="mailto:svi_coordinator@cdc.gov" className="icon-mail">
                        svi_coordinator@cdc.gov
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};
export default ContentInformation;
